import { render, staticRenderFns } from "./ProjectIncentives.vue?vue&type=template&id=cb730d18&scoped=true"
import script from "./ProjectIncentives.vue?vue&type=script&lang=js"
export * from "./ProjectIncentives.vue?vue&type=script&lang=js"
import style0 from "./ProjectIncentives.vue?vue&type=style&index=0&id=cb730d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb730d18",
  null
  
)

export default component.exports